module.exports = __webpack_public_path__ + "img/allegift-logo.299a3b5e.png";